/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFoodTruckEventTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFoodTruckEvent,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy Food Together!",
    "Food Truck Event Awaits!",
    "Taste the Best of the City!",
  ],
  title: "Food Truck Event",
  description: "Organize a fun food truck event.",
  longDescription:
    "Gather your friends for an exciting food truck event! Choose a date, decide on food trucks to invite, and plan activities!",
  emoji: "🍔",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Food Truck Event",
          emoji: "🍔",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the food truck event?",
          emoji: "📅",
          completeAction: {
            question: "Decide on food trucks to invite?",
            description: "What food trucks should we include in the event?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What food trucks should we consider?",
                emoji: "🚚",
                completeAction: {
                  question: "Decide on activities for the event?",
                  description:
                    "What activities should we plan during the event?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Feast Together!",
    outroDescription:
      "Your food truck event plans are set! Enjoy the delicious food!",
  },
};
